import { Box } from '@chakra-ui/react';

export const formatMetricDate = (value) => {
    if (!value) return 'n/a';
    const date = new Date(`${value}T00:00:00Z`);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
};

export const formatMetricValue = (value, unit) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 'n/a';

    const normalizedUnit = String(unit || '').toLowerCase();
    const suffix = normalizedUnit.includes('million')
        ? 'M'
        : normalizedUnit.includes('billion')
            ? 'B'
            : normalizedUnit.includes('thousand')
                ? 'K'
                : normalizedUnit.includes('percent')
                    ? '%'
                    : '';

    const formatted = Math.abs(numeric) >= 100
        ? numeric.toLocaleString(undefined, { maximumFractionDigits: 0 })
        : numeric.toLocaleString(undefined, { maximumFractionDigits: 2 });

    return suffix === '%' ? `${formatted}%` : `${formatted}${suffix}`;
};

export function PublicPageShell({ children }) {
    return (
        <Box maxW="1180px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 8, md: 12 }}>
            {children}
        </Box>
    );
}

export function publicMetricCtaPath(ticker, destination, content, metricSlug) {
    const normalizedTicker = String(ticker || '').toLowerCase();
    const path = `/stock/${normalizedTicker}/${destination}`;
    const params = new URLSearchParams({
        utm_source: 'public_metrics',
        utm_medium: 'seo',
        utm_campaign: 'custom_metrics',
        utm_content: content,
    });

    if (metricSlug) {
        params.set('public_metric', metricSlug);
    }

    return `${path}?${params.toString()}`;
}
